import { SortingOptions } from "./forhomeSortingOptions";

window.app.controller("finOffersCtrl", [
  "$scope",
  "$http",
  "$compile",
  "$sce",
  function ($scope, $sce, $http, $compile) {
    $scope.sce = $sce;
    $scope.offers = [];
    $scope.defaultParams = {
      amount: 1000,
      term: "30",
    };
    $scope.filterParams = localStorage.getItem("filterParams");
    localStorage.removeItem("filterParams");
    $scope.nestedCategories = {
      konto: ["konto-mlodziezowe", "konto-osobiste", "konto-oszczednosciowe"],
    };

    $scope.SortingOptions = SortingOptions;

    $scope.defs = {
      chwilowki: {
        term: "12:12",
        termDivider: 12,
        amount: 2000,
        sortBy: "",
      },
      pozyczki: {
        term: "30:365",
        amount: "1000",
        sortBy: "",
      },
      kredyty: {
        term: 12,
        termDivider: 12,
        amount: 1000,
        sortBy: "",
      },
      "lokaty-bankowe": {
        term: "12:12",
        termDivider: 12,
        amount: 10000,
        sortBy: "",
      },
    };
    $scope.category = window.location.pathname.split("/")[1];

    $scope.showBackLink = () => ($(".start-up-filter").length ? true : false);

    $scope.filters = {
      all: {},
    };

    $scope.selectedFiltersShow = false;
    $scope.offersShow = true;
    $scope.filtesParams = "";

    $scope.clearFilters = () => {
      $scope.filters.all = {};
      $scope.term = $scope.defs[$scope.category].term;
      $scope.amount = $scope.defs[$scope.category].amount;
      $scope.sortBy = $scope.defs[$scope.category].sortBy;
      let url = window.location.origin + window.location.pathname;
      window.history.pushState("offers", "Title", url);
      $scope.selectedFiltersShow = false;
      $scope.filtesParams = "";
      localStorage.removeItem("filterParams");
      $scope.getOffers();
    };

    $scope.reloadOffers = () => {
      window.onpopstate = (event) => {
        window.location.href = window.location.href;
      };
    };

    $scope.parseUrlParams = () => {
      let params = window.location.href.split("?")[1];
      if (params) {
        params = params.split("&");
        for (let i = 0; i < params.length; i++) {
          $scope.parseParams(params[i]);
        }
      }
    };

    $scope.filtersListener = () => {
      $(".finOffersFilter").on("change", function () {
        $scope.updateFilters();
      });
    };

    $scope.updateFilters = () => {
      // if ($scope.term && $scope.amount) {
      let filters = $(".js-filters-block").serializeArray();
      $scope.updateUrl(filters);
      $scope.filterParams = localStorage.getItem("filterParams");
      if (filters.length) $scope.selectedFiltersShow = true;
      else $scope.selectedFiltersShow = false;
      // }
    };

    $scope.clickEnter = function (keyEvent) {
      if (keyEvent.which === 13) $scope.updateFilters();
    };

    $("#kwota-input").keypress(function (e) {
      var txt = String.fromCharCode(e.which);
      if (!txt.match(/[0-9]/)) {
        return false;
      }
    });
    $("#okres-input").keypress(function (e) {
      var txt = String.fromCharCode(e.which);
      if (!txt.match(/[0-9]/)) {
        return false;
      }
    });

    $scope.updateUrl = (filters) => {
      let filtersParams = [];
      let selectParams = [];
      let checkedParams = [];

      $scope.term && selectParams.push(`term=${$scope.term}`);
      $scope.amount && selectParams.push(`amount=${$scope.amount}`);
      $scope.sortBy && selectParams.push(`sortBy=${$scope.sortBy}`);
      $scope.partner && selectParams.push(`partner=${$scope.partner}`);
      $scope.device && selectParams.push(`device=${$scope.device}`);
      if ($scope.otherSorts) {
        let paramObj = JSON.parse($scope.otherSorts);
        selectParams.push(`${paramObj.label}=${paramObj.value}`);
      }

      if (filters.length) {
        for (let i = 0; i < filters.length; i++) {
          checkedParams.push(filters[i].name);
        }
        checkedParams = "&filters=" + checkedParams.join(";");
      }

      let url = window.location.origin + window.location.pathname;
      $scope.filtesParams = selectParams.join("&") + checkedParams;
      window.history.pushState(
        "offers",
        "Title",
        url + "?" + selectParams.join("&") + checkedParams
      );
      $scope.filterParams = localStorage.setItem(
        "filterParams",
        "?" + $scope.filtesParams
      );
      $scope.getOffers();
    };

    $scope.getOffers = () => {
      $scope.offersShow = false;
      let params = $scope.filtesParams;
      $scope.sendXHR({
        url: `/rest/fin/catalog/offers?${params}`,
        data: "",
        method: "GET",
        headers: { "Content-Type": "application/json" },
        dataAsParam: false,
        successFunc: $scope.renderOffers,
        // errorFunc:  func,
      });
    };

    $scope.renderOffers = (response) => {
      $scope.scrollTo("body", 500);
      $(".fin-offers__cards").html(response.data.html);

      $scope.compare.domElementsUpdate();
      $scope.addBanner();
      $scope.addSubcriptionForm();
      $scope.addHint();
      $scope.addCubeMenu();

      $scope.offersShow = true;
    };

    $scope.filtersAsideHeight = () => {
      $(window).on("load scroll resize mouseover", function () {
        if (window.innerWidth >= 993) {
          let el = $(".fin-offers"),
            scrollTop = $(this).scrollTop(),
            scrollBot = scrollTop + $(this).height(),
            elTop = el.offset().top,
            elBottom = elTop + el.outerHeight(),
            visibleTop = elTop < scrollTop ? scrollTop : elTop,
            visibleBottom = elBottom > scrollBot ? scrollBot : elBottom,
            height = $("aside").hasClass("sticky")
              ? visibleBottom - visibleTop - 150
              : visibleBottom - visibleTop - 15;
          $(".offers-filters--aside").css("height", height + "px");
        }
      });
    };

    $scope.compare = {
      update: (e, alias = "") => {
        let list = $scope.compareList.list.get() || {};
        let page;
        alias
          ? (page = alias)
          : (page = window.location.pathname.split("/")[1]);
        let currentOffer = $(e.target).parents('div[class^="offer-card"]');
        let offer = {
          id: currentOffer[0].id,
          amount: $scope.amount,
          term: $scope.term,
          termDivider: $scope.termDivider,
        };
        let offerCard = $("#" + offer.id);
        if (offerCard.hasClass("compared")) {
          offerCard.removeClass("compared");
          $scope.compare.item.delete(list, page, offer);
        } else {
          if (list[page] == undefined || list[page].length <= 14) {
            offerCard.addClass("compared");
            $scope.compare.item.add(list, page, offer);
          }
        }
      },
      item: {
        add: (list, page, offer) => {
          list[page] = list[page] || [];
          if (list[page].length <= 14) {
            list[page].push(offer);
            $scope.compareList.list.set(list);

            $scope.compareList.createLink();
          }
        },
        delete: (list, page, offer) => {
          let items = list[page];
          for (let i = 0; i < items.length; i++) {
            if (
              items[i].id == offer.id &&
              items[i].amount == offer.amount &&
              items[i].term == offer.term
            ) {
              list[page].splice(i, 1);
            }
          }
          if (!list[page].length) {
            delete list[page];
          }
          $scope.compareList.list.set(list);
          $scope.compareList.createLink();
        },
      },
      domElementsUpdate: () => {
        let list = $scope.compareList.list.get() || {};
        let page;
        window.location.pathname.split("/")[2]
          ? (page = window.location.pathname.split("/")[2])
          : (page = window.location.pathname.split("/")[1]);
        if ($scope.nestedCategories[page]) {
          let subCategories = $scope.nestedCategories[page];
          for (let i = 0; i < subCategories.length; i++) {
            list[subCategories[i]]
              ? $scope.compare.addCompared(list[subCategories[i]])
              : "";
          }
        } else {
          list[page] ? $scope.compare.addCompared(list[page]) : "";
        }
      },
      addCompared: (comparedOffers) => {
        for (let i = 0; i < comparedOffers.length; i++) {
          if (
            comparedOffers[i].term == $scope.term &&
            comparedOffers[i].amount == $scope.amount
          ) {
            $("#" + comparedOffers[i].id).addClass("compared");
          }
        }
      },
    };

    $scope.parseParams = (paramString) => {
      let filt = paramString.split("=")[0];
      let val = paramString.split("=")[1];

      if (filt === "filters") {
        let filters = val.split(";");
        $scope.selectedFiltersShow = true;
        for (let i = 0; i < filters.length; i++) {
          let filtersItem = filters[i];
          $scope.filters.all[filtersItem] = true;
        }
      } else {
        $scope[filt] = val;
      }
    };

    $scope.cardsListener = (e) => {
      let el = e.target;
      let elParentId = $(el).parents('div[class^="offer-card"]')[0].id;
      if (el.classList.contains("add-to-compare-btn")) {
        el.getAttribute("alias")
          ? $scope.compare.update(e, el.getAttribute("alias"))
          : $scope.compare.update(e);
      }
      if (el.classList.contains("btn-show-offer-details")) {
        let offer = $("#" + elParentId);
        let deteils = offer.children(".offer-card__details");
        if (offer.hasClass("details-showed")) deteils.slideToggle("fast");
        else deteils.slideToggle("fast");
        offer.toggleClass("details-showed");
      }
    };

    class catalogBanner {
      constructor(href, order, src, mobSrc, company) {
        this.href = href;
        this.order = order;
        this.src = src;
        this.mobSrc = mobSrc;
        this.company = company;
      }

      renderHtml() {
        return `
            <a href=${this.href}
                class="ekassa-banner offer-card flex-100"
                style="padding: 0; order: ${this.order}"
                rel="nofollow"
                class="ga-track-click"
                ga-on="click,auxclick,contextmenu"
                ga-event-category="Outclick banner"
                ga-event-label="offers banner"
                target="_blank">
                <picture>
                    <source srcset="${this.src}" media="(min-width: 600px)">
                    <source srcset="${this.mobSrc}" media="(max-width: 600px)">
                    <img class="" style="width: 100%; height: auto; border-radius: 6px; margin-bottom: -3px;" alt="${this.company} banner">
                </picture>
            </a>`;
      }
    }

    $scope.addBanner = () => {
      $(".ekassa-banner").remove();
      // let credytsBanner = new catalogBanner('/stats/outclick/?offerId=5b7295a6ae0ce81d9175f517',
      //   -3, '/front/src/img/bnp-categories.jpg', '/front/src/img/bnp-categories.jpg', "BGZ BNP Paribas banner");
      // $($(".credits-offers")).append(credytsBanner.renderHtml());

      // let pozychkiBanner = new catalogBanner('/raport/',
      //     -4, '/front/src/img/bikfish/bik-long.png', '/front/src/img/bikfish/bik-long.png', "BIK report banner");
      // $($(".pozychki-offers")).append(pozychkiBanner.renderHtml());

      let chwilBanner = new catalogBanner(
        "/ranking/",
        -4,
        "/front/src/img/ranking.png",
        "/front/src/img/ranking.png",
        "Ranking banner"
      );
      $($(".chwilowki-offers")).append(chwilBanner.renderHtml());

      let lokatyBanner = new catalogBanner(
        "https://ekassa.eu/en/?utm_source=racoongo&utm_medium=banner&utm_campaign=returns_12&utm_content=900_240",
        -3,
        "/web/uploads/img/banners/lokaty_banner.jpg",
        "/web/uploads/img/banners/lokaty_banner_small.jpg",
        "Invest"
      );
      $($(".locaty-offers")).append(lokatyBanner.renderHtml());

      let carBanner = new catalogBanner(
        "https://ekassa.eu/en/?utm_source=racoongo&utm_medium=banner&utm_campaign=returns_12&utm_content=900_240",
        -3,
        "/web/uploads/img/banners/lokaty_banner.jpg",
        "/web/uploads/img/banners/lokaty_banner_small.jpg",
        "Invest"
      );
      $($(".car-offers")).append(carBanner.renderHtml());
    };

    $scope.init = () => {
      $scope.defaultFiltVal = $scope.defs[$scope.category];
      $scope.term = $scope.term || $scope.defaultFiltVal.term;
      $scope.termDivider =
        $scope.termDivider || $scope.defaultFiltVal.termDivider;
      $scope.amount = $scope.amount || $scope.defaultFiltVal.amount;
      $scope.sortBy = $scope.sortBy || $scope.defaultFiltVal.sortBy;
      // $scope.filtersListener();

      $scope.parseUrlParams();
      $scope.reloadOffers();
      $scope.filtersAsideHeight();
      $scope.compare.domElementsUpdate();
      $scope.addSubcriptionForm();

      $scope.addBanner();
    };

    $scope.cardInit = (a = false) => {
      if (a) {
        $scope.updateHomeFilters();
      }
      $scope.parseUrlParams();
      $scope.filtersAsideHeight();
      $scope.compare.domElementsUpdate();
    };

    $scope.initPozyczki = () => {
      $scope.defaultFiltVal = $scope.defs[$scope.category];
      $scope.term = $scope.term || $scope.defaultFiltVal.term;
      $scope.termDivider =
        $scope.termDivider || $scope.defaultFiltVal.termDivider;
      $scope.amount = $scope.amount || $scope.defaultFiltVal.amount;
      $scope.sortBy = $scope.sortBy || $scope.defaultFiltVal.sortBy;
      // $scope.filtersListener();

      $scope.parseUrlParams();
      $scope.reloadOffers();
      $scope.filtersAsideHeight();
      $scope.compare.domElementsUpdate();
      $scope.addSubcriptionForm();

      $scope.showFilters($scope.defaultParams);
      $scope.addBanner();
    };

    $scope.setOffersOrder = (offers) => {
      for (let i = 0; i < 11; i++) {
        if (i < 6 && offers[i]) offers[i].style.order = -3;
        else if (offers[i]) offers[i].style.order = -2;
      }
      if ($(".offer-card_hint")[1]) $(".offer-card_hint")[1].style.order = -2;
      if ($(".offer-card_hint")[0]) $(".offer-card_hint")[0].style.order = -2;
      if ($(".chwil-hint")[0]) $scope.manageChwilHints(offers);
    };

    $scope.manageChwilHints = (offers) => {
      offers.length < 10
        ? ($(".chwil-hint")[0].style.display = "none")
        : ($(".chwil-hint")[0].style.order = 0);
    };

    $scope.addSubcriptionForm = () => {
      let offers;
      if ($(".pozychki-offers").length !== 0) {
        offers = $(".pozychki-offers *.offer-card");
        $scope.setOffersOrder(offers);
      }
      if ($(".chwilowki-offers").length !== 0) {
        offers = $(".chwilowki-offers *.offer-card");
        $scope.setOffersOrder(offers);
      }
      // $scope.$watch('$viewContentLoaded', function() {
      //     if ($(offers[10]).length !== 0) {
      //         $($(offers[10])).after(subscribeForm);
      //     } else {
      //         $($(offers[offers.length - 1])).after(subscribeForm);
      //     }
      // });
    };

    $scope.addCubeMenu = () => {
      let cubeMenu = `
            <div class="catalog-cubes" style="width: 100%">
                    <div class="content-wrp main-content-wrp menuCubes">
                        <div class="feat-content-wrp"> 
                            <div class="feat-wrp sub-menu-ranking">
                                <a>
                                    <img alt="loan calculate image" src="/front/src/img/ranking-menu.png" class="hovered">
                                    <p class="title">Pożyczki</p>
                                </a>
                                <ul class="sub-menu">
                                    <li class="sub-menu-item"><a href="/pozyczki/">Pożyczki pozabankowe</a></li>
                                    <li class="sub-menu-item"><a href="/application/">Wniosek o pożyczkę</a></li>
                                    <li class="sub-menu-item"><a href="/raport/">Raport historii<br>kredytowej</a></li>
                                </ul>
                            </div>
                            <div class="feat-wrp sub-menu-kredyty">
                                <a>
                                    <img alt="credit image" src="/front/src/img/main_img-1.jpg" class="hovered">
                                    <p class="title">Kredyty</p>
                                </a>
                                <ul class="sub-menu">
                                    <li class="sub-menu-item"><a href="/kredyty/kredyt-gotowkowy/">Kredyt Gotówkowy</a></li>
                                    <li class="sub-menu-item"><a href="/kredyty/kredyt-konsolidacyjny/">Kredyt Konsolidacyjny</a></li>
                                    <li class="sub-menu-item"><a href="/karty-kredytowe/">Karty Kredytowe</a></li>
                                </ul>
                            </div>
                            <div class="feat-wrp sub-menu-kredyty">
                                <a>
                                    <img alt="credit image" src="/front/src/img/credit-history.png" class="hovered">
                                    <p class="title">Konto</p>
                                </a>
                                <ul class="sub-menu">
                                    <li class="sub-menu-item"><a href="/konto/konto-osobiste/">Konto osobiste</a></li>
                                    <li class="sub-menu-item"><a href="/konto/konto-mlodziezowe/">Konto młodzieżowe</a></li>
                                    <li class="sub-menu-item"><a href="/konto/konto-oszczednosciowe/">Konto oszczędnościowe</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="feat-content-wrp" style="margin-top: 16px;">
                            <div class="feat-wrp sub-menu-ranking">
                                <a href='/lokaty-bankowe'>
                                    <img alt="loan calculate image" src="/front/src/img/deposits-menu.jpg">
                                    <p class="title">Lokaty</p>
                                </a>
                            </div>
                            <div class="feat-wrp sub-menu-kredyty">
                                <a>
                                    <img alt="credit image" src="/front/src/img/insurance-menu.jpg" class="hovered">
                                    <p class="title">Ubezpieczenia</p>
                                </a>
                                <ul class="sub-menu">
                                    <li class="sub-menu-item"><a href="/ubezpieczenia-zycie/">Na życie</a></li>
                                    <li class="sub-menu-item"><a href="/ubezpieczenia-samochodu/">Samochodu</a></li>
                                    <li class="sub-menu-item"><a href="/ubezpieczenia-podrozy/">Turystycznych</a></li>
                                    <li class="sub-menu-item"><a href="/ubezpieczenia-nieruchomosci/">Nieruchomości</a></li>
                                </ul>
                            </div>
                            <div class="feat-wrp sub-menu-kredyty">
                                <a>
                                    <img alt="credit image" src="/front/src/img/for-home-menu.jpg" class="hovered">
                                    <p class="title">Dla domu</p>
                                </a>
                                <ul class="sub-menu">
                                    <li class="sub-menu-item"><a href="/internet/">Internet</a></li>
                                    <li class="sub-menu-item"><a href="/tv/">Telewizja</a></li>
                                    <li class="sub-menu-item"><a href="/telefon/">Telefon</a></li>
                                </ul>
                            </div>
                        </div>

                        <div class="mob-feat-wrp" style="width: 100%;">
                         <div class="dop-menu_wrapper-m">
                             <h2 class="dop-menu_title">Inne uslugi</h2>
                                <div class="dop-menu_card">
                                     <a class="dop-menu_a-inner" href="/kredyty/kredyt-gotowkowy/">
                                        <p>Kredyty</p>
                                        <img src="/front/src/img/new_design/shevron.svg" alt="Kredyty">
                                     </a>
                                </div>
                                <div class="dop-menu_card">
                                    <a class="dop-menu_a-inner"  href="/konto/">
                                        <p>Konto</p>
                                       <img src="/front/src/img/new_design/shevron.svg" alt="Konto">
                                    </a>
                                </div>
                                <div class="dop-menu_card">
                                    <a class="dop-menu_a-inner" href="/lokaty-bankowe/">
                                        <p>Lokaty</p>
                                        <img src="/front/src/img/new_design/shevron.svg" alt="Lokaty">
                                     </a>
                                 </div>
                                <div class="dop-menu_card">
                                     <a class="dop-menu_a-inner" href="/internet/">
                                         <p>Dla domu</p>
                                         <img src="/front/src/img/new_design/shevron.svg" alt="dom">
                                     </a>
                                </div>
                         </div>
                        </div>
                    </div>
            </div>
        `;
      $($(".pozychki-offers")).append(cubeMenu);
      $($(".credits-offers")).append(cubeMenu);
      $($(".chwilowki-offers")).append(cubeMenu);
      $($(".locaty-offers")).append(cubeMenu);
    };

    $scope.addHint = () => {
      let hint = ` <!--    OFFER HINT-->
            <div class="offer-card offer-card_hint triangle-container mob-hint priority-3">
                <div class="md-title hint_label">Porady Pożyczkowe</div>
                <div layout layout-align="space-betweeen flex-start" class="flex-100" style="display: flex;">
                    <div flex-sm="15" flex-xs="30" class="flex-sm-15 flex-xs-30">
                        <div class="img-wrp">
                            <img alt="racoon with pointer" src="/front/src/img/logo-smart.png">
                        </div>
                    </div>
                    <div class="offer-card_hint_desc">
                        <p class="hint_title">Zwiększ prawdopodobieństwo zaciągnięcia kredytu do 99%</p>
                        <p class="hint_subtitle">Wyślij wniosek kredytowy do kilku firm jednocześnie!</p>
                    </div>
                </div>
            </div>
            <div class="offer-card offer-card_hint triangle-container flex-100 hide-xs hide-sm priority-3">
                <div flex="30">
                    <div class="md-title hint_label">Porady Pożyczkowe</div>
                    <div class="img-wrp">
                        <img alt="racoon with pointer" src="/front/src/img/logo-smart.png">
                    </div>
                </div>
                <div class="offer-card_hint_desc">
                    <p class="hint_title">Zwiększ prawdopodobieństwo zaciągnięcia kredytu do 99%</p>
                    <p class="hint_subtitle">Wyślij wniosek kredytowy do kilku firm jednocześnie!</p>
                    <p class="hint_desc">Wyślij wniosek kredytowy do kilku firm jednocześnie!
                        Wysyłając zapytanie do kilku firm jednocześnie, zwiększasz prawdopodobieństwo otrzymania
                        pożyczki w jak najkrótszym czasie.
                        Jeśli w jednym przedsiębiorstwie pożyczka nie zostanie zatwierdzona, nie przegap szansy na
                        jej zdobycie w innym.
                    </p>
                </div>
            </div>`;

      $($(".pozychki-offers")).prepend(hint);
      $($(".credits-offers")).prepend(hint);
      $($(".chwilowki-offers")).prepend(hint);
      $($(".card-offers")).prepend(hint);
    };

    window.onbeforeunload = function () {
      $scope.removeLocalStorageFilter.removeStorage();
    };

    //MY FUNC ON POZYCZKI

    $scope.myFilters = [];
    $scope.filterAll = document.querySelectorAll("input");

    $(".checked").on("click", function () {
      if ($(this).parent().hasClass("check-filter")) {
        return;
      }
      if ($(this).attr("type") === "radio") {
        $(this).parent().siblings().removeClass("check-filter");
      }
      $(this).parent().toggleClass("check-filter");
    });
    //change class of radio, that look like button

    //uncheck filters
    $scope.unCheck = function () {
      $("input[type = 'radio']").click(function () {
        let previousValue = $(this).attr("previousValue");

        if (previousValue === "checked") {
          $(this).prop("checked", false);
          $(this).attr("previousValue", false);
          $(this).parent().removeClass("check-filter");
        } else {
          $(this).attr("previousValue", "checked");
          $(this).prop("checked", true);
          $(this).parent().addClass("check-filter");
        }

        $(this)
          .parent()
          .siblings()
          .find($("input"))
          .attr("previousValue", false);
        $scope.takeFilters();
      });
    };

    $scope.unCheck("");

    $scope.backToTop = function (time) {
      $("html, body").animate({ scrollTop: 0 }, time);
    };

    $scope.takeFilters = function () {
      //Take all filters in one array
      $scope.myFilters.splice(0);

      $scope.filterAll.forEach((item) => {
        if (item.checked) {
          $scope.myFilters.push({
            key: `${item.name}`,
            value: `${item.value}`,
          });
        }
        //if checkbox - checked - push it to array - filters
      });
    };

    $scope.showFilters = function (params = null) {
      $scope.offersShow = false;
      $scope.filtersData = {};

      //rewrite all data from array to object
      for (let i = 0; i < $scope.myFilters.length; i++) {
        $scope.filtersData[$scope.myFilters[i].key] = $scope.myFilters[i].value;
      }

      if (params) {
        $scope.restData = params;
      } else {
        $scope.restData = $scope.filtersData;
      }

      $scope.sendXHR({
        url: `/api/front/offer/offer`,
        data: $scope.restData,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        dataAsParam: false,
        successFunc: function success(response) {
          $scope.termOffers = response.data.termUnit;
          $scope.amountOffers = response.data.amount;

          $scope.offers = response.data.data;
          $scope.addSubcriptionForm();
        },
      });
    };

    $scope.deleteFilters = function () {
      //Delete filters - clear array
      $scope.offersShow = true;
      $scope.filterAll.forEach((item) => {
        if (item.checked) {
          $scope.myFilters.length = 0;
        }
      });
      //show all filters
      $scope.showFilters();

      $(".checked").parent().siblings().removeClass("check-filter");
      $("input").each((item) => {
        if ($("input").prop("checked", true)) {
          $("input").prop("checked", false);
        }
      });
    };

    //FUNCTION FOR HOME
    $scope.homeFilters = {};

    $scope.cardHomeInit = () => {
      $scope.updateHomeFilters();
      $scope.parseUrlParams();
      $scope.filtersAsideHeight();
      $scope.compare.domElementsUpdate();
    };

    $scope.updateHomeFilters = () => {
      let filters = $(".js-filters-block").serializeArray();
      $scope.filterParams = localStorage.getItem("filterParams");
      if (filters.length) $scope.selectedFiltersShow = true;
      else $scope.selectedFiltersShow = false;

      const category = window.location.pathname.slice(1, -1);

      $scope.homeFilters.category = category;
      $scope.partner && ($scope.homeFilters.partner = $scope.partner);
      if ($scope.otherSorts) {
        let paramObj = JSON.parse($scope.otherSorts);
        $scope.homeFilters[paramObj.label] = paramObj.value;
      }
      $scope.getHomeOffers();
    };

    $scope.getHomeOffers = () => {
      $scope.offersShow = false;

      $scope.sendXHR({
        url: `/api/front/offer/for-home`,
        data: $scope.homeFilters,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        dataAsParam: false,
        successFunc: function success(response) {
          $scope.homeOffers = response.data.offers;
          $scope.partnerFilter = response.data.partnerFilter;
        },
      });
    };

    //INFO FOR TOP_OFFERS
    $scope.topOffers = [
      {
        id: 1,
        mozliwa_kwota: "100 - 10 000 PLN",
        mozliwy_okres: "1 - 30 dni",
        promocji: "Weż pożyczkę wygraj 300 zł",
        title: "bigcredit",
        logo: "/web/front/src/img/partners/bigcredit.png",
        outclick: "/stats/outclick/?offerId=73",
      },
      {
        id: 2,
        mozliwa_kwota: "200 - 4 000 PLN",
        mozliwy_okres: "5 - 31 dni",
        promocji: "pierwsza pożyczka do 3000 zł RRSO od 0%",
        title: "halocredit",
        logo: "/uploads/img/partner_logo/5bf7bf462a533016276954d6.png",
        outclick: "/stats/outclick/?offerId=56",
      },
      {
        id: 3,
        mozliwa_kwota: "100 - 5 000 PLN",
        mozliwy_okres: "1 - 30 dni",
        title: "filarum",
        logo: "/uploads/img/partner_logo/5b169ba3ae0ce820ac3a7552.png",
        outclick: "/stats/outclick/?offerId=12",
      },
      {
        id: 4,
        mozliwa_kwota: "100 - 25 000 PLN",
        mozliwy_okres: "5 - 360 dni",
        title: "KomfortPożyczka",
        logo: "/web/front/src/img/partners/komfort.png",
        outclick: "/stats/outclick/?offerId=85",
      },
      {
        id: 5,
        mozliwa_kwota: "100 - 25 000 PLN",
        mozliwy_okres: "5 dni - 1 rok",
        title: "CreditExpres",
        logo: "/web/front/src/img/partners/creditexpres.png",
        outclick: "/stats/outclick/?offerId=84",
      },
    ];

    $scope.moneyAmount = [
      100,
      500,
      1000,
      1500,
      2000,
      2500,
      3000,
      3500,
      4000,
      4500,
      5000,
    ];
    $scope.monthAmount = ["1", "2", "3", "6", "12", "24", "36"];

    $scope.throttle = function (func, ms) {
      let isThrottled = false,
        savedArgs,
        savedThis;

      function wrapper() {
        if (isThrottled) {
          // (2)
          savedArgs = arguments;
          savedThis = this;
          return;
        }

        func.apply(this, arguments); // (1)

        isThrottled = true;

        setTimeout(function () {
          isThrottled = false; // (3)
          if (savedArgs) {
            wrapper.apply(savedThis, savedArgs);
            savedArgs = savedThis = null;
          }
        }, ms);
      }

      return wrapper;
    };
    $scope.quantity = 1000;
    $scope.month = "1";
    $scope.sendFilters = function () {
      $scope.sendXHR({
        url: `/api/front/offer/offer`,
        data: {
          amount: $scope.quantity,
          term: $scope.month,
        },
        method: "POST",
        headers: { "Content-Type": "application/json" },
        dataAsParam: false,
        successFunc: function success(response) {
          $scope.termOffers = response.data.termUnit;
          $scope.amountOffers = response.data.amount;
          $scope.offers = response.data.data;
        },
      });
    };
    $scope.sendFilters();

    let slider = document.getElementById("myRange");
    let output = document.getElementById("demo");

    if (output && slider) {
      output.innerHTML = slider.value;
      slider.onchange = $scope.throttle(function () {
        $scope.moneyAmount.forEach((item) => {
          if (item <= this.value) {
            $scope.quantity = item;
          }
        });
        $scope.sendFilters();
      }, 1000);

      slider.oninput = function () {
        output.innerHTML = this.value;
      };
    }

    let sliderSecond = document.getElementById("mySecondRange");
    let outputSecond = document.getElementById("demoSecond");

    if (outputSecond && sliderSecond) {
      outputSecond.innerHTML = sliderSecond.value;

      sliderSecond.onchange = $scope.throttle(function () {
        $scope.monthAmount.forEach((item) => {
          if (+item <= +this.value) {
            $scope.month = item;
          }
        });
        $scope.sendFilters();
      }, 1000);

      sliderSecond.oninput = function () {
        $scope.monthAmount.forEach((item) => {
          if (+item <= +this.value) {
            outputSecond.innerHTML = item;
          }
        });
      };
    }
  },
]);



// WEBPACK FOOTER //
// src/js/controllers/offers/finOffers/finOffersCtrl.js